import DropdownMenuItemContainer from 'components/DropdownMenuItemContainer';
import CheckmarkIcon from 'components/icons/CheckmarkIcon';
import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OrganizationDropdownMenuItem: FunctionComponent<Props> = ({
    className = '',
    isActive = true,
    testId = TEST_ID,
    value
}) => (
    <DropdownMenuItemContainer
        className={className}
        isActive={isActive}
        key={value}
        testId={testId}>
        <BodyText className={styles.navigationText} text={value} />

        {isActive && <CheckmarkIcon className={styles.checkmark} />}
    </DropdownMenuItemContainer>
);

export default OrganizationDropdownMenuItem;
